(function(){
     'use strict';

     angular
        .module('app')
        .factory('AnaliticaService', AnaliticaService);

    AnaliticaService.$inject = ['$http'];

    function AnaliticaService($http){
        
        var ga_measurement_id = "UA-80262876-1";
        var gaes_analitica =  gtag;    
        
        

        var service= {
            pageView:pageView,
            event:event
        };

        

        return service;



        function pageView(page_title,page_location,page_path){
            gtag('event', 'page_view', {
                    "page_title": page_title,
                    "page_location": page_location,
                    "page_path": page_path
                });
        }

        function event(action,category,label,value)
        {
            gtag('event', action, {
                      'event_category': category,
                      'event_label': label,
                      'value': value
                });
        }
    }
})();